module.exports = __webpack_public_path__ + "img/NBS.fa0ca61f.png";